module.exports = __webpack_public_path__ + "static/img/so5_1.8e639d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so5_1.jpg
// module id = KrFz
// module chunks = 11